import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import AmenClickStats from "../../components/admin/AmenClickStats"
import apiClient from "../../lib/api"
import { adminPath } from "../../lib/adminHost"
import type { IAmenClickStats } from "@dc-ireland/shared"

const sections = [
  {
    title: "Events",
    description: "Create and manage upcoming gatherings shown on the homepage.",
    segment: "events",
    action: "Manage Events",
  },
  {
    title: "Sermons",
    description: "Manage YouTube sermon embeds in the Inspiring Sermons section.",
    segment: "sermons",
    action: "Manage Sermons",
  },
  {
    title: "Locations",
    description: "Edit branch addresses and service times for Our Locations.",
    segment: "locations",
    action: "Manage Locations",
  },
  {
    title: "Hero Slideshow",
    description: "Update homepage carousel images and captions.",
    segment: "hero-slides",
    action: "Edit Slideshow",
  },
  {
    title: "Weekly Declaration",
    description: "Edit the weekly declaration and view Amen analytics.",
    segment: "weekly-declaration",
    action: "Manage Declaration",
  },
  {
    title: "Message of the Day",
    description: "Manage categories and messages for Chronicles of Love, Touch of Heaven, and more.",
    segment: "message",
    action: "Manage Messages",
  },
  {
    title: "Submissions",
    description: "Review prayer requests and testimonies from visitors.",
    segment: "prayer-requests",
    action: "View Submissions",
  },
  {
    title: "File Upload",
    description: "Upload images and copy URLs for events and content.",
    segment: "upload",
    action: "Upload Files",
  },
]

const AdminOverview = () => {
  const [amenStats, setAmenStats] = useState<IAmenClickStats | null>(null)

  useEffect(() => {
    const loadStats = async () => {
      try {
        const stats = await apiClient.getAmenClickStats()
        setAmenStats(stats)
      } catch (err) {
        console.error("Failed to load amen click stats:", err)
      }
    }

    loadStats()
  }, [])

  return (
    <div className="space-y-8">
      {amenStats && <AmenClickStats stats={amenStats} />}

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {sections.map(({ title, description, segment, action }) => (
          <div key={segment} className="card bg-base-100 shadow-xl">
            <div className="card-body">
              <h2 className="card-title">{title}</h2>
              <p>{description}</p>
              <div className="card-actions justify-end">
                <Link to={adminPath(segment)} className="btn btn-primary">
                  {action}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AdminOverview
